export function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val);
}
export function isNaN(val) {
  if (Number.isNaN) {
    return Number.isNaN(val);
  } // eslint-disable-next-line no-self-compare


  return val !== val;
}


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.25@vant/es/utils/validate/number.js
// module id = 43
// module chunks = 38